<template>
  <div class="import-tool">
    <Modal v-model="visible" :mask-closable="false" :title="name" :footer-hide="true" width="550" class="my-modal top import-tool-modal2">
      <div class="box">
        <p class="text1">操作步骤：</p>
        <p class="text2">1、点击“下载模板”按钮</p>
        <p class="text2">2、根据模板中的提示，将批量导入数据整理至模板中</p>
        <p class="text2">3、点击“上传excel”，将整理好的excel确认上传</p>
        <p class="text2">4、如存在导入异常记录，请及时处理</p>
      </div>

      <div class="ivu-modal-footer">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button type="primary" @click="download"><i class="iconfont icondaoru1"></i>下载模板</Button>
        <Upload
          ref="upload"
          v-if="data.uploadUrl"
          :show-upload-list="false"
          class="upload-btn"
          :max-size="2048"
          :before-upload="uploadExecl"
          :action="data.uploadUrl"
        >
          <Button type="primary" :loading="uploadExcelLoading">
            <i class="iconfont icondaochu" v-if="!uploadExcelLoading"></i>
            上传excel
          </Button>
        </Upload>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      fileFormat: ['xls', 'xlsx', 'XLS', 'XLSX'],
      data: {},
      name: '',
      uploadExcelLoading: false
    };
  },

  methods: {
    open(data = {}) {
      this.data = data;
      this.name = data.name;
      this.uploadExcelLoading = false;
      this.visible = true;
    },

    // 将url转成blob文件
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },

    //下载文件 　　js模拟点击a标签进行下载
    saveAs(blob, filename) {
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },

    // 下载模板
    download() {
      if (typeof this.data.downloadFun == 'function') {
        this.data.downloadFun();
        return;
      }
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code: this.data.dicKey
        }
      }).then(res => {
        const url = res.data[0].value;
        const fileName = res.data[0].txt;
        this.getBlob(url).then(blob => {
          this.saveAs(blob, fileName);
        });
      });
    },

    // 上传Excel
    uploadExecl(file) {
      if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$Message.error('请上传格式为xls或xlsx的文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      this.$units.downloadFile(this.data.uploadUrl, formData, 'POST')
      // this.$http({
      //   url: this.data.uploadUrl,
      //   type: 'POST',
      //   forced: true,
      //   responseType: 'blob',
      //   All: true,
      //   data: formData
      // })
      //   .then(res => {
      //     console.log(res)
      //     this.$Message.success('上传成功');
      //     this.visible = false;
      //     this.$emit('success');
      //   })
      //   .catch(error => {
      //     this.uploadExcelLoading = false;
      //   });
      // return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .ivu-modal-header-inner {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
  }
  .ivu-modal-close {
    top: 4px;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #a8adb7;
    }
  }
  .ivu-modal-header {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  .box {
    padding-top: 15px;
    padding-bottom: 10px;
    font-size: 12px;
    .text1 {
      color: #515c6f;
      margin-bottom: 15px;
    }
    .text2 {
      margin-bottom: 10px;
      .strong {
        color: red;
        font-weight: bold;
      }
    }
  }
  .ivu-modal-footer {
    border-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
    .iconfont {
      font-size: 14px;
      margin-right: 4px;
    }
    .upload-btn {
      margin-left: 10px;
    }
    button + button {
      margin-left: 10px;
    }
  }
  .upload-image {
    width: 120px;
    margin-left: 10px;
  }
}
</style>
